// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_openSnackbar(param) {
  
}

var defaultValue_geo_region = {
  geo_region_id: -1,
  geo_region_name: ""
};

var defaultValue_vehicle_type = {
  vehicle_id: -1,
  vehicle_name: ""
};

function defaultValue_refetch_core_pricings(param) {
  
}

var defaultValue_role = {
  TAG: /* User */2,
  _0: {
    first_name: "",
    last_name: "",
    email: ""
  }
};

function defaultValue_setActiveTab(param) {
  
}

var defaultValue = {
  openSnackbar: defaultValue_openSnackbar,
  geo_region: defaultValue_geo_region,
  vehicle_type: defaultValue_vehicle_type,
  refetch_core_pricings: defaultValue_refetch_core_pricings,
  role: defaultValue_role,
  setActiveTab: defaultValue_setActiveTab
};

var context = React.createContext(defaultValue);

function useContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useContext ,
  
}
/* context Not a pure module */
